<template>
  <v-container>
    <template>
      <v-card class="RiyoushaBox">
        <v-card-text>
          aiueo
        </v-card-text>
      </v-card>
    </template>
    <template>
      <v-card class="RiyoushaBox">
        <v-card-text>
          kakikukeko
        </v-card-text>
      </v-card>
    </template>
    
  </v-container>
</template>
      
<script>
export default {};
</script>
      
<style>
  .RiyoushaBox {
    margin: 8px;
    border: 1px solid rgb(147, 179, 204);
  }
</style>
      